/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../models/meevo.dtos.d.ts"/>
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../common/common.interface.ts"/>

module Meevo.Components.Controls {
    'use strict';

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;

    export class ReportingHierarchyLocationsCtrl implements angular.IComponentController {
        static $inject = [
            '$scope',
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            "meevo.components.common.IdentityService"
        ];

        //scope of component
        revision: number = 0;
        businessTypeForHierarchy: string;
        hierarchyForHierarchy: string;
        branchIdForHierarchy: string;
        locationForHierarchy: string[];
        shortCut: string;
        reportAvailability: number;
        isBusinessTypesModuleEnabled: boolean;
        reportId: number;

        businessTypes: Meevo.Model.BusinessType[] = [];
        hierarchies: any[] = [];
        excludedLocationList: any[] = [];

        locations: any[] = [];

        ngModelCtrl: angular.INgModelController;
        nullableId = '00000000-0000-0000-0000-000000000000';
        fetchingData = '';
        adjustForMobile: boolean = false;

        get noLocations(): boolean {
           
            return this.locations.length === 0;
        }

        constructor(
            private $scope: angular.IScope,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            private identityService: Meevo.Components.Common.IIdentityService
        ) {
        }

        $onInit() {
            if (this.shortCut && (this.shortCut === 'DC041' || this.reportAvailability == 1)) {
                this.getExcludeLocation();
            }
            if (this.excludedLocationList && this.shortCut && (this.shortCut !== 'DC041' && this.reportAvailability != 1)) {
                delete this.excludedLocationList;
            }
            if (this.shortCut && this.shortCut === 'COMR010') {
                this.adjustForMobile = true;
            }
            if (!angular.isDefined(this.businessTypeForHierarchy)) this.businessTypeForHierarchy = null;
            if (!angular.isDefined(this.hierarchyForHierarchy)) this.hierarchyForHierarchy = null;
            if (!angular.isDefined(this.branchIdForHierarchy)) this.branchIdForHierarchy = null;
            if (!angular.isDefined(this.locationForHierarchy)) this.locationForHierarchy = [];
            this.setWatchers();

            this.getBusinessTypes();
        }

        updateRevision = _.debounce(() => {
            this.revision += 1;
            this.$scope.$apply();
        }, 1000);

        setWatchers() {
            this.$scope.$watch(() => this.businessTypeForHierarchy, (newVal, oldVal) => {
                if (!angular.equals(newVal, oldVal) && oldVal !== null) {
                    this.getHierarchies();
                }
            });

            this.$scope.$watch(() => this.hierarchyForHierarchy, (newVal, oldVal) => {
                if (!angular.equals(newVal, oldVal)) {
                    this.branchIdForHierarchy = null;
                    this.fetchingData = 'Branches';
                }
            });

            this.$scope.$watch(() => this.branchIdForHierarchy, (newVal, oldVal) => {
                if (newVal !== null && !angular.equals(newVal, oldVal)) {
                    this.fetchingData = '';
                    this.getLocations();
                }
            });

            this.$scope.$watch(() => this.locationForHierarchy, (newVal) => {
                if (newVal.length == 0) return;
                this.ngModelCtrl.$setValidity('locationsSelected', newVal instanceof Array && newVal.length > 0);
            }, true);
        }

        getExcludeLocation() {
            this.dataService.customMethodData(`api/Report/ExclusionLocation/List`, 'POST', {
                excludeCOLocation: true,
                excludeCallCenterLocation: false
            }).then((res: any) => {
                this.excludedLocationList = res.data;
            });
        }
        hasUserBusinessTypes() {
            return this.isBusinessTypesModuleEnabled && this.identityService.userBusinessTypes.length > 0;
        }

        getBusinessTypes() {
            if (this.hasUserBusinessTypes() && this.identityService.inCentralOfficeMode()) {
                this.fetchingData = 'Business Types';
                this.dataService.getListPaged('userbusinesstype', {})
                    .then((businessTypes: Meevo.Model.BusinessType[]) => {
                        this.fetchingData = '';
                        //if (!businessTypes.length) {
                        //    this.modalService.alert('LABEL_THIS_REPORT_CANNOT_BE_RUN', ModalTranslationModes.Translate);
                        //    this.ngModelCtrl.$setValidity('noBusinessTypesAssociated', false);

                        //    return;
                        //}

                        this.businessTypes = businessTypes
                            .map(bt => {
                                if (bt.id === this.nullableId) bt.id = null;
                                return bt;
                            });
                        if (this.businessTypes.length > 0) {
                            this.businessTypeForHierarchy = this.businessTypes[0].id;
                        }
                        this.getHierarchies();
                    });
            }
            else {
                this.getHierarchies();
            }
        }

        getHierarchies() {
            this.hierarchyForHierarchy = null;
            this.branchIdForHierarchy = null;
            this.fetchingData = 'Hierarchies';
            this.dataService.customMethodData(
                `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.reportingHierarchy}/List`,
                'POST',
                {
                    'Criteria': {
                        'CoBusinessTypeId': this.businessTypeForHierarchy === null
                            ? this.nullableId
                            : this.businessTypeForHierarchy
                    }
                }).then((res: any) => {
                    this.hierarchies = res.data;
                    this.fetchingData = '';

                    if (this.hierarchies.length === 0) {
                        this.getLocationsForBusinessType();
                    } else if (this.hierarchies.length === 1) {
                        this.hierarchyForHierarchy = this.hierarchies[0].id;
                    } else {
                        this.ngModelCtrl.$setValidity('locationsSelected', false);
                    }
                });
        }
        

        getLocations() {
            this.fetchingData = 'Locations';
            this.dataService.customMethodData(
                `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.reportingHierarchy}Leaf/List`,
                'POST',
                {
                    'Criteria': {
                        'HierarchyId': this.hierarchyForHierarchy,
                        'BranchId': this.branchIdForHierarchy,
                        'OnlyIds': false,
                        'ForMultipleBranches': true,
                        'ReportId': this.reportId
                    },
                    'PageNumber': 0,
                    'ItemsPerPage': 100000
                }).then(res => {
                    this.locations = res.data;
                    this.setLocations();

                    // show warning message if selected tier has no locations associated
                    if (!this.locations.length) {
                        this.modalService.warning('LABEL_NO_LOCATIONS_ARE_ASSOCIATED', ModalTranslationModes.Translate);
                    }
                });
        }

        getLocationsForBusinessType() {
            let data: any = {
                'criteria': {
                    'BusinessType_Tbl': [this.businessTypeForHierarchy],
                    'FieldOrderBy': 'StoreName',
                    'OrderAscDesc': 'Ascending',
                    'IncludeStoreName': true,
                    'ReportId': this.reportId,
                },
                'itemsPerPage': 100000,
                'pageNumber': 0
            };

            if (this.shortCut && (this.shortCut.startsWith('CO'))) {
                data.criteria['ExcludeCOLocation'] = true;
                data.criteria['ExcludeCallCenterLocation'] = false;
                data.criteria['ExcludeIdList'] = this.excludedLocationList;
                data.criteria['IsSpecificReport'] = true;
            }


            if (this.shortCut && (this.shortCut === 'DC041' || this.reportAvailability == 1)) {
                data.criteria['ExcludeCOLocation'] = true;
                data.criteria['ExcludeCallCenterLocation'] = false;
                data.criteria['ExcludeIdList'] = this.excludedLocationList;
                data.criteria['IsSpecificReport'] = true;
            }

            this.fetchingData = 'Locations';
            this.dataService.getListPaged(`Report/Location`, data).then((res: any[]) => {
                this.locations = res
                    .map(location => {
                        const {id, storeName} = location;
                        return {
                            locationId: id,
                            storeName: storeName,
                            selected: false
                        };
                    });

                if (this.locations.length === 0) {
                    this.locationForHierarchy = [];
                }

                this.setLocations();
            });
        }

        setLocations() {
            this.updateRevision();
            this.ngModelCtrl.$setValidity('locationsSelected', this.locations.length > 0);
            this.fetchingData = '';
        }
    }
}
